import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function PremiumUpsell() {
  return <section className="py-10 md:py-20 px-4" data-id="element-211">
      <div className="max-w-5xl mx-auto" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-213">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-navy-dark mb-3 md:mb-4" data-id="element-214">
            ¿Qué agregan los Volúmenes 7 y 8 Premium?
          </h2>
          <p className="text-base md:text-lg text-gray-700" data-id="element-215">
            Para orientadores que quieren ir un paso más allá
          </p>
        </motion.div>

        <div className="space-y-6 md:space-y-8 mb-8 md:mb-12" data-id="element-216">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-217">
            <div className="bg-navy-dark text-cream-bg p-4" data-id="element-218">
              <span className="text-xs md:text-sm font-bold" data-id="element-219">01 / 02</span>
              <h3 className="font-serif text-xl md:text-2xl font-bold mt-1" data-id="element-220">
                Más allá del juego — Volumen 7
              </h3>
              <p className="text-cream-bg/80 text-sm md:text-base" data-id="element-221">
                Adicciones conductuales más allá de la ludopatía
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4 md:gap-6 p-4 md:p-6" data-id="element-222">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-223">
                <div className="flex items-start gap-2 mb-2" data-id="element-224">
                  <X className="w-4 h-4 md:w-5 md:h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-225" />
                  <span className="font-bold text-navy-dark text-sm md:text-base" data-id="element-226">
                    Sin Premium
                  </span>
                </div>
                <p className="text-gray-700 text-xs md:text-sm" data-id="element-227">
                  La persona llega con compras compulsivas o adicción a
                  pantallas y no sabés si lo que aprendiste aplica igual o cómo
                  adaptarlo.
                </p>
              </div>

              <div className="bg-gold/10 p-4 rounded-lg border-2 border-gold" data-id="element-228">
                <div className="flex items-start gap-2 mb-2" data-id="element-229">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-230" />
                  <span className="font-bold text-navy-dark text-sm md:text-base" data-id="element-231">
                    Con Premium
                  </span>
                </div>
                <p className="text-gray-700 text-xs md:text-sm" data-id="element-232">
                  Sistema completo para trabajar compras compulsivas, adicción a
                  pantallas y conductas sexuales compulsivas con las mismas
                  herramientas adaptadas a cada presentación.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-233">
            <div className="bg-navy-dark text-cream-bg p-4" data-id="element-234">
              <span className="text-xs md:text-sm font-bold" data-id="element-235">02 / 02</span>
              <h3 className="font-serif text-xl md:text-2xl font-bold mt-1" data-id="element-236">
                El grupo como herramienta — Volumen 8
              </h3>
              <p className="text-cream-bg/80 text-sm md:text-base" data-id="element-237">
                Cómo crear y facilitar grupos de acompañamiento
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4 md:gap-6 p-4 md:p-6" data-id="element-238">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-239">
                <div className="flex items-start gap-2 mb-2" data-id="element-240">
                  <X className="w-4 h-4 md:w-5 md:h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-241" />
                  <span className="font-bold text-navy-dark text-sm md:text-base" data-id="element-242">
                    Sin Premium
                  </span>
                </div>
                <p className="text-gray-700 text-xs md:text-sm" data-id="element-243">
                  Querés armar un grupo en tu ONG o centro de día pero no sabés
                  cómo estructurarlo, facilitarlo ni manejar los momentos
                  difíciles dentro del grupo.
                </p>
              </div>

              <div className="bg-gold/10 p-4 rounded-lg border-2 border-gold" data-id="element-244">
                <div className="flex items-start gap-2 mb-2" data-id="element-245">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-246" />
                  <span className="font-bold text-navy-dark text-sm md:text-base" data-id="element-247">
                    Con Premium
                  </span>
                </div>
                <p className="text-gray-700 text-xs md:text-sm" data-id="element-248">
                  Protocolo completo para crear el grupo desde cero, facilitar
                  el primer encuentro, manejar situaciones difíciles y sostener
                  el espacio en el tiempo sin formación formal en grupos.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-navy-dark text-cream-bg p-5 md:p-8 rounded-lg" data-id="element-249">
          <h3 className="font-bold text-lg md:text-xl mb-4" data-id="element-250">
            PACK PREMIUM INCLUYE:
          </h3>
          <div className="space-y-4" data-id="element-251">
            <div className="flex items-start gap-3" data-id="element-252">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-253" />
              <div data-id="element-254">
                <p className="font-bold text-sm md:text-base" data-id="element-255">
                  V7 — Más allá del juego
                </p>
                <p className="text-cream-bg/80 text-xs md:text-sm mt-1" data-id="element-256">
                  Compras compulsivas, adicción a pantallas y conductas sexuales
                  compulsivas. El circuito es el mismo: aprendé a adaptarlo.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-257">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-258" />
              <div data-id="element-259">
                <p className="font-bold text-sm md:text-base" data-id="element-260">
                  V8 — El grupo como herramienta
                </p>
                <p className="text-cream-bg/80 text-xs md:text-sm mt-1" data-id="element-261">
                  Cómo crear, facilitar y sostener grupos de acompañamiento en
                  adicciones conductuales desde cero.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}